export enum PayoutType {
    Manual = 'manual',
    Automatic = 'automatic',
    Log = 'log',
    Markup = 'markup',
}
